import { addUtmTrackerParam, addUtmTrackers } from '@ifixit/analytics';
import { useAppContext } from '@ifixit/app/hooks';
import { useAuthenticatedUser } from '@ifixit/auth-sdk';
import { useStoreLocale } from '@ifixit/i18n/hooks';
import { useCart } from './use-cart';

type Checkout = {
   checkoutUrl: string | undefined;
};

export function buildCheckoutUrl(
   rawCheckoutUrl: string,
   opts: { ifixitOrigin: string; storeLocale: string; isLoggedIn: boolean }
): string {
   const checkoutUrl = new URL(rawCheckoutUrl);
   addUtmTrackerParam(checkoutUrl);
   addUtmTrackers(checkoutUrl);
   if (!opts.isLoggedIn) return checkoutUrl.toString();
   const ssoRoute = `${opts.ifixitOrigin}/User/sso/shopify/${opts.storeLocale}?checkout=1`;
   const ssoUrl = new URL(ssoRoute);
   ssoUrl.searchParams.set('return_to', checkoutUrl.toString());
   return ssoUrl.toString();
}

export function useCheckout(): Checkout {
   const { ifixitOrigin } = useAppContext();
   const storeLocale = useStoreLocale();
   const user = useAuthenticatedUser();
   const cartQuery = useCart();
   if (!cartQuery.data?.checkoutUrl) {
      return { checkoutUrl: undefined };
   }
   return {
      checkoutUrl: buildCheckoutUrl(cartQuery.data.checkoutUrl, {
         ifixitOrigin,
         storeLocale,
         isLoggedIn: Boolean(user.data),
      }),
   };
}
